<template>
  <article class="trainers" v-if="charged">


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Editar entrenador</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  @click="$router.push({name: 'classes_trainers'})"
                  class="breadcums__option"
                >
                  Entrenadores
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  disabled
                  class="breadcums__disable"
                >
                  Editar entrenador
                </v-breadcrumbs-item>
              </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-0">
              <button
                class="faccess_button px-5"
                @click="editLocation()"
              >
                Guardar
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info">
        <v-layout row wrap>
          <v-flex xs6>
            <!-- Fotos de la oferta -->
            <span class="data_card__info--label">Foto</span>
            <div class="trainers__form--photo_container">
              <label
                for="trainerPhoto"
                style="
                width: 160px;
                height: 34px;"
                class="trainers__form--photo_button">Examinar</label>
              <input
                id="trainerPhoto"
                type="file"
                @change="onFileChange"
                name="logo">
              <p>{{ photo_name }}</p>
            </div>
            <v-flex xs12>
              <span class="data_card__info--label">Nombre</span>
              <input
                class="trainers__form--input"
                type="text"
                name="Name"
                placeholder="Nombre del entrenador"
                v-model="location.attributes.name">
            </v-flex>
            <v-flex xs12>
              <span class="data_card__info--label">Descripción</span>
              <input
                class="trainers__form--input"
                type="text"
                name="Name"
                placeholder="Descripción"
                v-model="location.attributes.description">
            </v-flex>
            <v-flex xs12>
              <span class="data_card__info--label">Dirección</span>
              <input
                class="trainers__form--input"
                type="text"
                name="Address"
                placeholder="Dirección"
                v-model="location.attributes.address">
            </v-flex>
            <v-flex xs12>
              <span class="data_card__info--label">Correo electrónico</span>
              <input
                class="trainers__form--input"
                type="email"
                name="Email"
                placeholder="Correo electrónico"
                v-model="location.attributes.email">
            </v-flex>
            <v-flex xs12>
              <span class="data_card__info--label">Teléfono</span>
              <input
                class="trainers__form--input"
                type="tel"
                name="Phone"
                placeholder="Numero de teléfono"
                v-model="location.attributes.telephone">
            </v-flex>
            <v-flex xs12>
              <span class="data_card__info--label">Ciudad</span>
              <input
                class="trainers__form--input"
                type="text"
                name="City"
                placeholder="Ciudad"
                v-model="location.attributes.city">
            </v-flex>
          </v-flex>
          <v-flex xs6 >
            <v-flex xs11 offset-xs1>
              <section class="data_card data_card__instance">
                <div
                  class="data_card__image"
                  :class = "{'without_url' : !url_change}"
                  :style="{backgroundImage: 'url('+ image_url +')'}"></div>
                <div class="data_card__info">
                  <div class="data_card__info--container">
                    <p class="data_card__info--title">
                      {{location.attributes.name}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Descripción</span>
                    <p class="data_card__info--text">
                      {{location.attributes.description}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Dirección</span>
                    <p class="data_card__info--text">
                      {{location.attributes.address}}
                    </p>
                  </div>
                  <div class="data_card__info--container">
                    <span class="data_card__info--label">Correo electrónico</span>
                    <p class="data_card__info--text">
                      {{location.attributes.email}}
                    </p>
                  </div>
                </div>
              </section>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          class="faccess_button px-5"
          @click="editLocation()"
        >
          Crear
        </button>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      location: '',
      charged: false,
      image_url: '',
      schedule_url: '',
      qr_text: '',
      photo_name: 'No se han seleccionado archivos',
      url_change: false,
      url:'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg'
    }
  },
  mounted(){
    var path = this.$route.path.split('/')
    try {
      this.$http.get('locations/'+ path[2],)
      .then(function(response){
        this.location = response.body.data
        this.charged = true
        if(this.location.attributes.image){
          this.image_url = this.getImageServer() + this.location.attributes.image.url
          this.url_change = true
        }else{
          this.image_url = 'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg'
        }
        this.schedule_url = this.location.attributes.schedule_image.url!=null ? this.getImageServer() + this.location.attributes.schedule_image.url : ''
        this.qr_text = this.location.id
      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
      } catch (e) {
        alert(e.message)
      }
  },
  methods:{
    create_qr (){
      var qrcode = new QRCode(document.getElementById("qrcode"));
      qrcode.makeCode(this.location.id);
      this.qr = !this.qr;
      $("canvas").width("100%");
      $("canvas").css({"margin-left":"auto", "margin-right": "auto"});
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this[e.target.dataset.url] = URL.createObjectURL(files[0]);
      this.image_url = URL.createObjectURL(files[0]);
      this.photo_name = files[0].name
      this.createImage(files[0],""+e.target.name)
    },
    createImage (file,name_field) {
      var reader = new FileReader()
      var vm = this;
      reader.readAsDataURL(file);
      reader.onload = function () {
        vm.location.attributes.image = reader.result
      }
    },
    editLocation(){
      this.location.attributes.title = this.location.attributes.name
      try {
        this.$http.patch('locations/'+ this.location.id, {data: this.encrypt(this.location).toString()},
          {headers:
            {"X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()}})
        .then(function(response){
          if (this.location.attributes.is_trainer) {
            this.$router.push({name: 'classes_trainers'})
          }else{
            this.$router.push({name: 'location'})
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/classes/Edit_trainer.vue